import React, { useState } from 'react';
import { Phone, Menu, X, Shield, BadgePoundSterling, Receipt } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const badges = [
    { icon: Shield, text: "12-Month Guarantee" },
    { icon: BadgePoundSterling, text: "Price Promise" },
    { icon: Receipt, text: "No VAT" }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      {/* Top badges bar */}
      <div className="bg-slate-800 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 flex justify-center gap-6 md:gap-12">
          {badges.map((badge, index) => (
            <div key={index} className="flex items-center gap-2 text-xs md:text-sm">
              <badge.icon className="w-4 h-4 text-amber-400" />
              <span className="font-medium">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Main header */}
      <div className="bg-white/95 backdrop-blur-md shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <a href="/" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_skilled-plastering/artifacts/8k6l7pp4_plasterer%20logo.png" 
                alt="Expert Plasterer Logo"
                className="h-16 w-auto"
              />
            </a>

            {/* Desktop navigation */}
            <nav className="hidden md:flex items-center gap-8">
              <a href="#services" className="text-slate-600 hover:text-amber-600 transition-colors font-medium">Services</a>
              <a href="#pricing" className="text-slate-600 hover:text-amber-600 transition-colors font-medium">Prices</a>
              <a href="#reviews" className="text-slate-600 hover:text-amber-600 transition-colors font-medium">Reviews</a>
              <a href="#contact" className="text-slate-600 hover:text-amber-600 transition-colors font-medium">Contact</a>
            </nav>

            {/* CTA buttons */}
            <div className="flex items-center gap-3">
              <a href={`tel:${businessInfo.phone}`} className="hidden sm:flex items-center gap-2 text-slate-700 hover:text-amber-600 transition-colors">
                <Phone className="w-5 h-5" />
                <span className="font-semibold">{businessInfo.phone}</span>
              </a>
              <Button 
                asChild
                className="bg-amber-500 hover:bg-amber-600 text-white shadow-lg shadow-amber-200 transition-all hover:shadow-xl hover:shadow-amber-300"
              >
                <a href="#contact">Get Quote</a>
              </Button>
              
              {/* Mobile menu button */}
              <button 
                className="md:hidden p-2 text-slate-600 hover:text-amber-600 transition-colors"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>

          {/* Mobile menu */}
          {isMenuOpen && (
            <nav className="md:hidden mt-4 pt-4 border-t border-slate-100">
              <div className="flex flex-col gap-3">
                <a href="#services" className="text-slate-600 hover:text-amber-600 transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)}>Services</a>
                <a href="#pricing" className="text-slate-600 hover:text-amber-600 transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)}>Prices</a>
                <a href="#reviews" className="text-slate-600 hover:text-amber-600 transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)}>Reviews</a>
                <a href="#contact" className="text-slate-600 hover:text-amber-600 transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)}>Contact</a>
                <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-2 text-amber-600 font-semibold py-2">
                  <Phone className="w-5 h-5" />
                  {businessInfo.phone}
                </a>
              </div>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
